import { useEffect, useState } from 'react';

// Touch scrolling is composited independently of JS scroll events. Keep hero
// media and actions in the native scroll flow there; retain desktop parallax.
export const HERO_SCROLL_MOTION_QUERY = '(min-width: 768px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)';

export function useHeroScrollMotion() {
  const [enabled, setEnabled] = useState(() => (
    typeof window !== 'undefined' && !!window.matchMedia?.(HERO_SCROLL_MOTION_QUERY).matches
  ));

  useEffect(() => {
    const media = window.matchMedia?.(HERO_SCROLL_MOTION_QUERY);
    if (!media) return undefined;
    const update = () => setEnabled(media.matches);
    update();
    media.addEventListener?.('change', update);
    return () => media.removeEventListener?.('change', update);
  }, []);

  return enabled;
}
